import { Link } from "react-router-dom";
import { categories, gossipItems } from "@/mocks/gossip";
import { formatViews } from "@/utils/format";

const sideIds = ["1002", "1004", "1015"];

export default function Hero() {
  const featured = gossipItems[0];
  const sideItems = sideIds
    .map((id) => gossipItems.find((item) => item.id === id))
    .filter((item): item is (typeof gossipItems)[number] => Boolean(item));

  return (
    <section aria-labelledby="hero-title" className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-500 mb-4">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-2.5 py-1 text-primary-700 font-medium">
            <i className="ri-flashlight-line w-3.5 h-3.5 flex items-center justify-center"></i>
            今日热瓜已更新
          </span>
          <span>2026 年 9 月 10 日 · 收录 8,600+ 段现场画面</span>
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
          <article className="lg:col-span-7 group">
            <h1 id="hero-title" className="sr-only">
              视频吃瓜第一现场 · 热门现场视频聚合
            </h1>
            <Link to={`/video/${featured.id}`} className="block cursor-pointer">
              <div className="relative w-full h-[280px] md:h-[420px] overflow-hidden rounded-lg bg-foreground-900">
                <img
                  src={featured.cover}
                  alt={`${featured.title} - 视频吃瓜第一现场`}
                  title={`${featured.title} 视频吃瓜 第一现场`}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/35 to-transparent"></div>

                <span className="absolute top-4 left-4 inline-flex items-center gap-1 rounded-md bg-accent-500 px-2.5 py-1 text-xs font-semibold text-foreground-950">
                  <i className="ri-fire-line w-3.5 h-3.5 flex items-center justify-center"></i>
                  本周最高热度
                </span>

                <div className="absolute bottom-0 left-0 w-full p-5 md:p-7">
                  <div className="flex flex-wrap items-center gap-2 mb-3">
                    <span className="rounded-full bg-background-50/20 px-2.5 py-1 text-xs text-background-50 backdrop-blur-sm">
                      {formatViews(featured.views)} 次播放
                    </span>
                    <span className="rounded-full bg-background-50/20 px-2.5 py-1 text-xs text-background-50 backdrop-blur-sm">
                      {featured.duration}
                    </span>
                  </div>
                  <h2 className="font-heading text-xl md:text-3xl font-bold leading-snug text-background-50 text-balance">
                    {featured.title}
                  </h2>
                  <p className="mt-3 max-w-2xl text-sm leading-relaxed text-background-100/90 line-clamp-2">
                    {featured.excerpt}
                  </p>
                  <span className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-4 py-2.5 text-sm font-medium text-foreground-950 transition-colors group-hover:bg-accent-400">
                    <i className="ri-play-circle-fill w-5 h-5 flex items-center justify-center text-primary-600"></i>
                    立即观看
                  </span>
                </div>
              </div>
            </Link>
          </article>

          <div className="lg:col-span-5 flex flex-col">
            <div className="flex items-center justify-between mb-4">
              <h2 className="font-heading text-lg font-bold text-foreground-950">今日必看</h2>
              <Link to="/#ranking" className="whitespace-nowrap text-xs text-primary-600 cursor-pointer transition-colors hover:text-primary-700">
                查看热榜
              </Link>
            </div>
            <div className="flex flex-1 flex-col gap-3">
              {sideItems.map((item, index) => (
                <Link
                  key={item.id}
                  to={`/video/${item.id}`}
                  className="group flex flex-1 cursor-pointer gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300"
                >
                  <div className="relative w-28 h-20 md:w-32 md:h-20 flex-shrink-0 overflow-hidden rounded-md bg-secondary-200">
                    <img
                      src={item.cover}
                      alt={`${item.title} 现场画面缩略图`}
                      title={`${item.title} 视频吃瓜 现场`}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                    <span className="absolute inset-0 flex items-center justify-center">
                      <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-foreground-950/50 text-background-50">
                        <i className="ri-play-fill w-3.5 h-3.5 flex items-center justify-center"></i>
                      </span>
                    </span>
                  </div>
                  <div className="min-w-0 flex flex-col justify-center">
                    <span className="text-xs text-primary-600 font-medium mb-1">NO.{index + 2} 热度位</span>
                    <h3 className="font-heading text-sm font-semibold leading-snug text-foreground-950 line-clamp-2 transition-colors group-hover:text-primary-600">
                      {item.title}
                    </h3>
                    <span className="mt-1.5 text-xs text-foreground-500">{formatViews(item.views)} 次播放 · {item.duration}</span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-8 flex flex-wrap items-center gap-2 md:gap-3">
          <span className="text-xs text-foreground-500 mr-1">快速进入：</span>
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-3.5 py-1.5 text-sm text-foreground-700 cursor-pointer transition-colors hover:border-primary-400 hover:bg-primary-50 hover:text-primary-700"
            >
              <i className={`${cat.icon} w-4 h-4 flex items-center justify-center text-primary-500`}></i>
              {cat.name}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}